module.exports = __webpack_public_path__ + "static/media/delete.298c76c9.svg";